import globalMU from "globalMU";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { TextField } from "@mui/material";
import { Alert, Autocomplete } from "@mui/material";

const estiloResponsaveisServicosAgregados = require("./responsaveis-servicos-agregados.module.scss").default;
const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type ExecutorServico = {
    Nome: string;
    Oid: number;
}

export type ResponsaveisServicoAgregado = {
    IdentificadorItem: number;
    CodigoProduto: string;
    DescricaoProduto: string;
    CodigoServico: string;
    DescricaoServico: string;
    Quantidade: number;
    Valor: number;
    TaxaIss: number;
    ServicoEmbutidoValorProduto: number;
    ExecutorOid?: number;
}


export type ServicosAgregadosProps = {
    dados: ResponsaveisServicoAgregado[];
    listaExecutores: ExecutorServico[];
    ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado: boolean;
    ExibirTaxaIssServicoAgregado: boolean;
    SomenteLeitura: boolean
    processando: boolean
    onConfirmar: (agregadosSelecionados: ResponsaveisServicoAgregado[]) => void;
    onLimpar: () => void;
};

export const ResponsaveisServicosAgregados = (props: ServicosAgregadosProps) => {
    // 447380
    const [listaServicosAgregados, setListaServicosAgregados] = useState<ResponsaveisServicoAgregado[]>(props.dados);

    const formik = useFormik({
        initialValues: { ...props.dados },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });


    const onChangeExecutor = (index: number, executor:  ExecutorServico) => {
        var servicoAgregadoComValorAlterado =  listaServicosAgregados[index];
        servicoAgregadoComValorAlterado.ExecutorOid = executor.Oid;
        formik.setFieldValue("listaServicosAgregagadosComExecutores",listaServicosAgregados.splice(index,1,servicoAgregadoComValorAlterado));
        setListaServicosAgregados(listaServicosAgregados)
    }
    
    const botaoConfirmar = <button
                            className={estiloResponsaveisServicosAgregados.button}
                            id="ResponsaveisServicosAgregados_btnConfirmar"
                            type="button"
                            disabled={props.processando}
                            onClick={() => props.onConfirmar(listaServicosAgregados)}
                        >
                            Confirmar Escolha do Executor
                        </button>
/*
    const botaoLimpar = <button
                            className={estiloResponsaveisServicosAgregados.buttonLimpar}
                            id="ResponsaveisServicosAgregados_btnLimpar"
                            type="button"
                            onClick={() => {setListaServicosAgregados(null); props.onLimpar()}}
                            
                        >
                            Limpar
                        </button>
*/
    const alertaIss = <Alert className="_w-[600px] _mt-1" variant="outlined" severity="warning"
        id="ResponsaveisServicosAgregados_AlertaISS"
    >
                        Há serviços agregados com alíquotas de ISS diferentes.
                    </Alert>

    
    const selecionarExecutor = (index:number) => 
                                    <Autocomplete
                                        id="ResponsaveisServicosAgregados_listaServicosAgregagadosComExecutores"
                                        disablePortal
                                        disableClearable={true}
                                        options={props.listaExecutores}
                                        value={props.listaExecutores.find(x => x.Oid === listaServicosAgregados[index].ExecutorOid)}
                                        isOptionEqualToValue={(option, value) => { return option.Oid === value?.Oid} }
                                        getOptionLabel={(option) => { return option?.Nome}}
                                        style={{backgroundColor: "white"}}
                                        disabled={props.SomenteLeitura || props.processando}
                                        onChange={(event,valor) => {
                                            onChangeExecutor(index,valor as ExecutorServico)
                                        }}
                                        renderInput={
                                            (params) => 
                                                // Migração MUI v4 -> v9: o `InputLabelProps={{shrink:true}}` que ficava aqui
                                                // não tinha efeito NENHUM — vinha ANTES do `{...params}`, e o params do
                                                // Autocomplete já traz o seu próprio InputLabelProps, que sobrescrevia.
                                                // Removido preservando o comportamento atual (no v9 o equivalente seria
                                                // `slotProps.inputLabel`, e continuaria sendo sobrescrito pelo spread).
                                                <TextField
                                                    label="Escolha um executor"
                                                    variant="outlined"
                                                    {...params}
                                                    
                                                    
                                                />
                                        }
                                    />             

    const colunas = [
        { texto: "Código", coluna: "Codigo", estilo: "_text-center" },
        { texto: "Descrição Do Produto", coluna: "DescricaoProduto", estilo: "_text-left" },
        { texto: "Quantidade", coluna: "Quantidade", estilo: "_text-center" },
        { texto: "Serviço", coluna: "Servico", estilo: "_text-left" },
        { texto: "ISS", coluna: "TaxaIss", estilo: "_text-right" },
        { texto: "Executor", coluna: "ExecutorServico", estilo: "_text-left _w-[300px]" },
    ];

    const cabecalhoTabelaExecutoresServicosAgregados = () => (
        <thead>
            <tr
                id="ResponsaveisServicosAgregados_CabecalhoTabela"
            >
                {colunas
                .filter(x => props.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado || x.coluna != "ExecutorServico")
                .filter(x => props.ExibirTaxaIssServicoAgregado || x.coluna != "TaxaIss")
                .map((x) => <th key={x.texto}>
                    {<div 
                        className={`_justify-between ${x.estilo}`}
                        >
                        {x.texto}
                    </div>
                    }
                </th>)}
            </tr>
        </thead>
    )


   
    useEffect(() => {
        setListaServicosAgregados(props.dados);
    }, [props.dados]);

    return (
        <>
            <div className={estiloResponsaveisServicosAgregados.separador}>
               
                <div>
                    <table className={`_table _w-full _border-collapse ${estiloTabela.tabela} ${estiloResponsaveisServicosAgregados.tabelaServicosAgregados}`}
                        id="ResponsaveisServicosAgregados_TabelaServicosAgregados"
                    >
                        {cabecalhoTabelaExecutoresServicosAgregados()}
                        <tbody
                            id="ResponsaveisServicosAgregados_CorpoTabela"
                        >

                            {listaServicosAgregados?.map((dado,index) => {
                                return (
                                    <tr
                                        id="ResponsaveisServicosAgregados_LinhaTabela"
                                    >
                                        <td className="_text-center">{dado.CodigoProduto}</td>
                                        <td>{dado.DescricaoProduto}</td>
                                        <td className="_text-center">{ globalMU.formatarValorNumerico(dado.Quantidade, 3, false)}</td>
                                        <td>{dado.DescricaoServico}</td>
                                        {props.ExibirTaxaIssServicoAgregado &&
                                        <td className="_text-right">{ globalMU.formatarValorNumerico(dado.TaxaIss, 2, false)}</td>}
                                        {props.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado &&
                                        <td className={`_h-[12px] ${estiloResponsaveisServicosAgregados.colunaInput}`}>
                                            {selecionarExecutor(index)}
                                        </td>}
                                    </tr>
                                );
                            })}


                        </tbody>
                    </table>
                    <div>
                        {props.ExibirTaxaIssServicoAgregado ? alertaIss : null}
                        {props.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado && !props.SomenteLeitura && (
                            <>
                                {botaoConfirmar} 
                                {
                                //ver se será necessário o botão limpar
                                //botaoLimpar
                                }
                            </>
                        )}
                    </div>

                </div>
            </div>
        </>
    )
}